export const parseDateToLocalTime = (date: Date | string) => {
  return new Date(date).toLocaleString("en-GB", {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  });
};
